import { Component } from '@angular/core';

@Component({
  selector: 'app-asset-transfer-approve-landing-page',
  templateUrl: './asset-transfer-approve-landing-page.component.html',
  styleUrls: ['./asset-transfer-approve-landing-page.component.scss']
})
export class AssetTransferApproveLandingPageComponent {

}
